import { t, useLanguage } from "@/i18n/LanguageContext";import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";
import LanguageSwitcher from "@/components/LanguageSwitcher";

const LINKS = [
{ to: "/", label: "Home", testid: "nav-link-home" },
{ to: "/chi-siamo", label: "Chi siamo", testid: "nav-link-chi-siamo" },
{ to: "/certificazioni", label: "Certificazioni", testid: "nav-link-certificazioni" },
{ to: "/bim", label: "BIM", testid: "nav-link-bim" },
{ to: "/lavori", label: "I nostri lavori", testid: "nav-link-lavori" },
{ to: "/contatti", label: "Contatti", testid: "nav-link-contatti" },
{ to: "/lavora-con-noi", label: "Lavora con noi", testid: "nav-link-careers" }];


export default function Navbar() {useLanguage();
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const dark = pathname === "/";

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 border-b backdrop-blur-md transition-colors duration-300 ${
      dark && !open ?
      "border-white/10 bg-brand-navydeep/80" :
      "border-slate-200/80 bg-white/90"}`
      }>
      
      <div className="mx-auto flex h-16 max-w-[1440px] items-center justify-between gap-2 px-4 sm:px-6 lg:px-8">
        <Link to="/" data-testid="nav-logo-link" className="flex items-center gap-3" onClick={() => setOpen(false)}>
          <span data-testid="nav-logo-frame" className="flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-full bg-white ring-1 ring-slate-200">
            <img data-testid="nav-logo-mark" src="/brand/gfc-simbolo.png" alt={t("Logo GFC Appalti Generali")} width="320" height="320" className="h-9 w-9 object-contain" />
          </span>
          <span data-testid="nav-company-name" className={`font-display text-xs font-bold leading-tight tracking-tight min-[380px]:text-sm sm:text-base ${dark && !open ? "text-white" : "text-brand-navy"}`}>{t("GFC Appalti Generali")}

            <span data-testid="nav-company-legal-form" className={`block text-[10px] font-medium uppercase tracking-[0.25em] ${dark && !open ? "text-brand-limebright" : "text-brand-limeink"}`}>{t("S.r.l.")}</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 2xl:flex" data-testid="nav-desktop">
          {t(LINKS.map((l) =>
          <NavLink
            key={l.to}
            to={l.to}
            data-testid={l.testid}
            className={({ isActive }) =>
            `rounded-full px-3 py-2 text-sm font-semibold transition-colors duration-200 ${
            isActive ?
            "bg-brand-lime text-brand-navy" :
            dark ?
            "text-white/80 hover:text-white" :
            "text-slate-600 hover:text-brand-navy"}`

            }>
            
              {t(l.label)}
            </NavLink>
          ))}
          <Link
            to="/preventivo"
            data-testid="nav-cta-button"
            className="ml-3 inline-flex items-center gap-1.5 rounded-full bg-brand-navy px-5 py-2.5 text-sm font-bold text-white transition-colors duration-200 hover:bg-brand-navydark">{t("Preventivo rapido ")}

            <ArrowUpRight className="h-4 w-4" />
          </Link>
        </nav>

        <div className="flex shrink-0 items-center gap-1">
        <LanguageSwitcher dark={dark && !open} />
        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen(!open)}
          aria-label={t("Apri menu")}
          className={`rounded-lg p-2 2xl:hidden ${dark && !open ? "text-white" : "text-brand-navy"}`}>
          
          {t(open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />)}
        </button>
        </div>
      </div>

      {t(open &&
      <nav className="border-t border-slate-200 bg-white px-4 pb-6 pt-2 2xl:hidden" data-testid="nav-mobile">
          {t(LINKS.map((l) =>
        <NavLink
          key={l.to}
          to={l.to}
          data-testid={`${l.testid}-mobile`}
          onClick={() => setOpen(false)}
          className={({ isActive }) =>
          `block rounded-lg px-4 py-3 text-base font-semibold ${
          isActive ? "bg-brand-limelight text-brand-navy" : "text-slate-700"}`

          }>
          
              {t(l.label)}
            </NavLink>
        ))}
          <Link to="/preventivo" data-testid="nav-quote-mobile" onClick={() => setOpen(false)} className="mt-3 block rounded-full bg-brand-amberdark px-4 py-3 text-center text-sm font-bold text-white">{t("Formula un preventivo")}</Link>
        </nav>)
      }
    </header>);

}
